import {
  type GetIssueRelationshipsResponseDto,
  type GetIssueResponseDto,
  type GetUserRolesResponseDto,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { UseQueryResult } from '@tanstack/react-query';
import { useOutletContext } from 'react-router-dom';

type ContextType = {
  code: string;
  issue: UseQueryResult<GetIssueResponseDto, ExtendedAxiosError>;
  userRoles: UseQueryResult<GetUserRolesResponseDto, ExtendedAxiosError>;
  canDiscardIssue: boolean;
  onDiscardIssue: () => void;
  relationships: GetIssueRelationshipsResponseDto[];
};

export function useIssueOutletContext(): ContextType {
  return useOutletContext<ContextType>();
}
